export enum Path {
  PRODUCT = 'p',
  CMS = 'cms',
  SHOP = 'shop',
}
